module.exports = "<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/app/theme/components/backTop/backTop.html
// module id = 793
// module chunks = 2